import React from "react";
import { ReceiptDetailData, ReceiptHistoryItem } from "../lib/api";

type BadgeInfo = { label: string; className: string };

type BadgeItem = Pick<ReceiptDetailData | ReceiptHistoryItem, "relayStatus" | "needsReview" | "isSettled">;

// 要確認→未精算→精算済みの一本の流れを1つのバッジで表す。
// needsReview=trueのジョブは精算できない(settle APIの制約)ため、要確認を最優先で表示する。
export function getReceiptStatusBadge(item: BadgeItem): BadgeInfo {
  if (item.relayStatus === "failed") {
    return { label: "エラー", className: "bg-red-100 text-red-700" };
  }
  if (item.relayStatus === "accepted") {
    return { label: "処理中", className: "bg-gray-100 text-gray-600" };
  }
  if (item.needsReview) {
    return { label: "要確認", className: "bg-orange-100 text-orange-700" };
  }
  if (item.isSettled) {
    return { label: "精算済み", className: "bg-blue-100 text-blue-700" };
  }
  return { label: "未精算", className: "bg-gray-100 text-gray-600" };
}

type Props = {
  item: BadgeItem;
};

export function ReceiptStatusBadge({ item }: Props) {
  const { label, className } = getReceiptStatusBadge(item);
  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-[11px] font-bold ${className}`}>
      {label}
    </span>
  );
}
